import { IApiResponse, IClaimNote, IClaimNoteReply } from '@/types';
import { ApiAuth } from '@/hooks/api/apiAuth';

export class NoteControllerApi {
  public static getNoteById(noteId: number): Promise<IApiResponse<unknown>> {
    return ApiAuth.get<unknown>(`/note/${noteId}`);
  }

  public static addNote(payload: IClaimNote): Promise<IApiResponse<void>> {
    return ApiAuth.post<void>('/note', payload);
  }

  public static updateNote(noteId: number, payload: IClaimNote): Promise<IApiResponse<void>> {
    return ApiAuth.put<void>(`/note/${noteId}`, payload);
  }

  public static getReplyById(replyId: number): Promise<IApiResponse<unknown>> {
    return ApiAuth.get(`/reply/${replyId}`);
  }

  public static addReply(payload: IClaimNoteReply): Promise<IApiResponse<void>> {
    return ApiAuth.post('/reply', payload);
  }

  public static updateReply(
    replyId: number,
    payload: IClaimNoteReply
  ): Promise<IApiResponse<void>> {
    return ApiAuth.put(`/reply/${replyId}`, payload);
  }
}
